<style src="./Navigator.scss" lang="scss" scoped></style>
<template>
  <div class="navigator">
    <button
      type="button"
      class="button-paginator"
      @click="goToPreviousPage"
      v-shortkey="['ctrl', 'arrowleft']"
      @shortkey="goToPreviousPage">
      <icon-left-arrow />
    </button>

    <button
      type="button"
      class="button-paginator first-button"
      :class="{'selected-page': value === 0}"
      @click="goToPage(0)"
      v-if="value > 2">
      1
    </button>

    <button
      type="button"
      class="button-paginator"
      :class="{'selected-page': page === value}"
      v-for="(page, pageIdx) in pages"
      :key="pageIdx"
      @click="goToPage(page)">
      {{ page + 1 }}
    </button>

    <button
      type="button"
      class="button-paginator last-button"
      :class="{'selected-page': value === totalPages}"
      @click="goToPage(totalPages)"
      v-if="value < totalPages - 2">
      {{ totalPages + 1 }}
    </button>

    <button
      type="button"
      class="button-paginator"
      @click="goToNextPage"
      v-shortkey="['ctrl', 'arrowright']"
      @shortkey="goToNextPage">
      <icon-right-arrow />
    </button>
  </div>
</template>

<script>
import { IconRightArrow, IconLeftArrow } from '@/components/primitives/icons'

export default {
  name: 'Navigator',
  components: {
    IconRightArrow,
    IconLeftArrow
  },
  props: {
    value: {
      default: 0
    },
    totalPages: {
      default: 0
    },
    perPage: {
      default: 20
    }
  },
  computed: {
    pages () {
      const prePages = []

      const firstPage = 0
      const lastPage = this.totalPages

      if (this.value - 2 >= firstPage) prePages.push(this.value - 2)
      if (this.value - 1 >= firstPage) prePages.push(this.value - 1)
      if (this.value >= 0 && this.value <= this.totalPages) prePages.push(this.value)
      if (this.value + 1 <= lastPage) prePages.push(this.value + 1)
      if (this.value + 2 <= lastPage) prePages.push(this.value + 2)

      return prePages
    }
  },
  methods: {
    goToNextPage () {
      if (this.value + 1 > this.totalPages) return
      const newPage = this.value + 1
      this.$emit('input', newPage)
    },
    goToPreviousPage () {
      if (this.value - 1 < 0) return
      const newPage = this.value - 1
      this.$emit('input', newPage)
    },
    goToPage (pPageNumber) {
      this.$emit('input', pPageNumber)
    },
    navigateShortcut () {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/paginator/navigator/Navigator.vue